import moment from 'moment';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

const TOTAL_ONBOARDING_STEPS = 8;

class OnboardingService {

  constructor(organizationService, sdkOrganizationService, analyticsService) {
    this._organizationService = organizationService;
    this._sdkOrganizationService = sdkOrganizationService;
    this._analyticsService = analyticsService;
  }

  get totalOnboardingSteps() { //eslint-disable-line
    return TOTAL_ONBOARDING_STEPS;
  }

  /**
   * @return {Boolean}
   */
  isCurrentOrganizationOnboardingComplete() {
    const currentOrganization = this._organizationService.getCurrentOrganization();

    if (!currentOrganization) return false;

    if (!currentOrganization.onboardingSteps) return false;

    let setupComplete = true;

    for (let key in currentOrganization.onboardingSteps) { //eslint-disable-line
      if (!currentOrganization.onboardingSteps[key]) {
        setupComplete = false;
        break;
      }
    }

    return setupComplete;
  }

  /**
   * @return {Boolean}
   */
  isCurrentOrganizationPastDue() {
    const currentOrganization = this._organizationService.getCurrentOrganization();

    if (!currentOrganization) return false;

    return currentOrganization.billingStatus === 'PAST_DUE' && currentOrganization.type === 'STANDARD_VENUE';
  }

  /**
   * @return {Boolean}
   */
  isCurrentOrganizationInTrialMode() {
    const currentOrganization = this._organizationService.getCurrentOrganization();

    if (!currentOrganization) return true;

    return currentOrganization.billingStatus === 'TRIAL' && currentOrganization.type === 'STANDARD_VENUE';
  }

  /**
   * @return {Number}
   */
  getCurrentOrganizationTrialDaysLeft() {
    const currentOrganization = this._organizationService.getCurrentOrganization();

    if (!currentOrganization) return 0;

    const created = moment.utc(currentOrganization.created, 'x');
    const today = moment.utc();
    const diff = today.diff(created, 'day');
    const daysLeft = 30 - diff;

    return daysLeft < 0 ? 0 : daysLeft;
  }

  /**
   * @return {Number}
   */
  getCurrentOrganizationStepsCompleted() {
    const currentOrganization = this._organizationService.getCurrentOrganization();

    if (!currentOrganization) return 0;

    if (!currentOrganization.onboardingSteps) return 0;

    let stepsCompleted = 0;

    for (let key in currentOrganization.onboardingSteps) { //eslint-disable-line
      if (currentOrganization.onboardingSteps[key]) {
        stepsCompleted++; //eslint-disable-line
      }
    }

    return stepsCompleted;
  }

  /**
   * @return {Number}
   */
  getCurrentOrganizationStepsRemaining() {
    return this.totalOnboardingSteps - this.getCurrentOrganizationStepsCompleted();
  }

  completeOnboardingStep(stepName) {
    if (!stepName) throw new Error('onboardingService - completeOnboardingStep() - stepName is required');

    const currentOrganization = this._organizationService.getCurrentOrganization();

    if (!currentOrganization) throw new Error('onboardingService - completeOnboardingStep() - currentOrganization is required');

    const onboardingSteps = currentOrganization.onboardingSteps || {};
    onboardingSteps[stepName] = true;

    return this._sdkOrganizationService.updateById(currentOrganization.id, {
        onboardingSteps: onboardingSteps
      })
      .then(updatedOrganization => {
        this._analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.COMPLETED_ACCOUNT_SETUP_STEP);

        if (this.isCurrentOrganizationOnboardingComplete()) {
          this._analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.COMPLETED_ACCOUNT_SETUP);
        }

        return updatedOrganization;
      });
  }
}

OnboardingService.$inject = [
  'organizationService',
  'jsSdk.organization',
  'analyticsService'
];

export default OnboardingService;



// WEBPACK FOOTER //
// ./src/services/onboardingService.js